export class CreateGrupoTipoGarantiaInquilinoRequest{
  public idGrupo!:number
  public idGrupoTipoGarantia!:number
  public descripcion!:string
  public idInquilino!: number
}
